import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

import leaf from "../../Assets/Projects/leaf.png";
import smartfiton from "../../Assets/Projects/smartfiton.jpg";
import search from "../../Assets/Projects/search.jpg";
import chatbott from "../../Assets/Projects/chatbott.JPG";

import credit from "../../Assets/Projects/credit.jpg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

        <Col md={5} className="project-card">
            <ProjectCard
              imgPath={smartfiton}
              isBlog={false}
              title="SmartFitOn"
              description="Built an automatic physical activity recognizer, which recognizes the human activity accurately, using the sensors of the phone.
              using machine learning techniques, Technology used: Machine Learning, Deep Learning, Android Studio, SQLite"
              link="https://github.com/Gayatri-Shastri7/SmartFitOn"
            />
          </Col>
          <Col md={5} className="project-card">
            <ProjectCard
              imgPath={chatbott}
              isBlog={false}
              title="Restaurant Recommendation Conversational AI"
              description="Restaurant bot is a self- learning chatbot to recommend restaurants, book tables based on users input like location and in type of cuisine which he/she would like to have.Technology used are : RASA, Zomato API, Python, Docker, NGROK"
              link="https://github.com/Gayatri-Shastri7/CLL-RestaurantBot"
            />
          </Col>
          <Col md={5} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="ML Zero-Hunger-Challenge "
              description="Predict the price of the crop using real time data of crops Groundnut, Maize, and Bengal Gram.Analyzed the type of crop, current price, and its location of harvest in Telangana. By analyzing these features one could predict the price of the crop.Technology used: ML, Tableau"
              link="https://github.com/Gayatri-Shastri7/Zero-Hunger-Challenge"
            />
          </Col>

          <Col md={5} className="project-card">
            <ProjectCard
              imgPath={search}
              isBlog={false}
              title="Search-Engine"
              description="Search Engine works when a user gives a sentence or paragraph as input, then the keyword which is present in the input is shown. This is achieved by writing a suitable query which should be in JSON format. Technology used : ElasticSearch, Python, Flask"
              link="https://github.com/Gayatri-Shastri7/Search-Engine"
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
